(() => {
  const id = "xencms:has-stars";

  const createStar = (color) => {
    const img = document.createElement("img");
    img.setAttribute("src", `/themes/custom/xencms/images/star-${color}.svg`);
    img.classList.add("star", `star--${color}`);
    return img;
  }

  Drupal.behaviors[id] = { attach: (context, settings) => {
    once(id, ".has-stars", context).forEach((element) => {
      const span = document.createElement("span");
      span.classList.add("position-relative");
      span.innerHTML = element.innerHTML;

      const left = document.createElement("span");
      left.classList.add("stars", "stars--left");
      left.append(createStar("yellow"));
      left.append(createStar("turquoise"));
      span.append(left);

      const right = document.createElement("span");
      right.classList.add("stars", "stars--right");
      right.append(createStar("yellow"));
      right.append(createStar("blue"));
      span.append(right);

      element.innerHTML = "";
      element.append(span);
    });
  }};
})();
